class Name {
  constructor(
    personalName,
    familyName,
    flatPersonalName,
    flatFamilyName
  ) {
    if (!(typeof personalName === "string")) {
      throw new TypeError(`The type of 'personalName' must be String. Actual: ${typeof personalName}`)
    }
    if (!(typeof familyName === "string")) {
      throw new TypeError(`The type of 'familyName' must be String. Actual: ${typeof familyName}`)
    }
    if (!(typeof flatPersonalName === "string")) {
      throw new TypeError(`The type of 'flatPersonalName' must be String. Actual: ${typeof flatPersonalName}`)
    }
    if (!(typeof flatFamilyName === "string")) {
      throw new TypeError(`The type of 'flatFamilyName' must be String. Actual: ${typeof flatFamilyName}`)
    }
    this.personalName = personalName
    this.familyName = familyName
    this.flatPersonalName = flatPersonalName
    this.flatFamilyName = flatFamilyName
  }

  static createFromObject(object) {
    if (!(object instanceof Object)) {
      throw new TypeError(`'object' must be an instance of [object Object]. Actual: ${typeof object}`)
    }
    return new Name(
      object.personalName,
      object.familyName,
      object.flatPersonalName,
      object.flatFamilyName
    )
  }

  toObject() {
    return {
      personalName: this.personalName,
      familyName: this.familyName,
      flatPersonalName: this.flatPersonalName,
      flatFamilyName: this.flatFamilyName,
    }
  }

  fullName() {
    return this.familyName + this.personalName
  }

  flatFullName () {
    return this.flatFamilyName + this.flatPersonalName
  }
}

export { Name }